import { useSelector } from "react-redux";
import { ROLES } from "../../util/constants";
import { selectAuthentication } from "../../services/authorization/slices";
import { useCallback } from "react";
import { compareAuthentication } from "../../services/util/selectorEquality";

function useRoleAuthentication() {
  const { roles = [], ...rest } = useSelector(selectAuthentication, compareAuthentication);

  const compareUserToRoles = useCallback((allowedRoles = []) => {
    const filteredArray = roles.filter(value => allowedRoles.includes(value));
    
    return process.env.REACT_APP_ACT_AS_STUDENT_ROLE === "true" || !!filteredArray?.length
  }, [roles])


  const isStudent = compareUserToRoles([ROLES.STUDENT])
  const isStaffFaculty = compareUserToRoles([ROLES.FACULTY, ROLES.STAFF, ROLES.EMPLOYEE])

  return {
    ...rest,
    roles,
    compareUserToRoles,
    isStudent,
    isStaffFaculty,
    isStaffFacultyNotStudent: !isStudent && isStaffFaculty,
    isStaffFacultyAndStudent: isStudent && isStaffFaculty
  }
}

export default useRoleAuthentication;